// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  envName: 'dev',
  googleMapKey: 'AIzaSyBTQUONuqiWMf5-Juwv7Kw33uuxP45pOBw',
  googleMapId: '8327008f8140c881',
  apiUrl: 'https://yoxnnhzq9a.execute-api.ap-northeast-1.amazonaws.com/staging/',
  apiKey: 'jz4ZBElc7U3HwQ0REwkYo8ZVrXYUfeOw7PzaRwqx'
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
